<template>
  <el-select clearable @change="handleChange" :value="data" placeholder="请选择">
    <el-option :label="item.name" :value="item.value" v-for="(item,index) in typeList" :key="index"></el-option>
  </el-select>
</template>

<script>
  export default {
    name: "CategoryStatus",
    props: ["value"],
    watch: {
      value: {
        immediate: true,
        handler: function(value) {
          this.data = value;
        }

      },

    },
    data() {
      return {
        data: "",
        typeList: [{
            name: "启用",
            value: 1
          },
          {
            name: "禁用",
            value: 2
          },
        ]
      }
    },
    methods: {
      handleChange(value) {
        this.data = value;
        this.$emit("input", value)
      }
    }
  }
</script>

<style scoped>

</style>
